import Badge from '@mui/material/Badge'

export default function Offline({ in: value, overlap = 'circular', children, ...rest }) {
  if (!value) return children

  return (
    <Badge
      variant="dot"
      overlap={overlap}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      {...rest}
      sx={{
        '& .MuiBadge-badge': {
          outline: '1px solid',
          outlineColor: 'background.paper',
          height: 10,
          minWidth: 10,
          borderRadius: '50%',
          backgroundColor: 'brand.magenta',
        },
      }}
    >
      {children}
    </Badge>
  )
}
